import { defineMessages } from 'react-intl';

type i18nType = {
	defaultMessage: string;
	description: string;
	id: string;
};

type LastUpdatedLabelsType = Record<string, i18nType>;

export const lastUpdatedLabels: LastUpdatedLabelsType = defineMessages({
	anytime: {
		id: 'dynamic-cards-search-page.filter.last.updated.anytime',
		defaultMessage: 'Anytime',
		description: 'Last updated filter anytime option label',
	},
	today: {
		id: 'dynamic-cards-search-page.filter.last.updated.today',
		defaultMessage: 'Today',
		description:
			'Drop-down item label shown in the last-updated date filter on the search page, representing the current calendar day as the time range.',
	},
	yesterday: {
		id: 'dynamic-cards-search-page.filter.last.updated.yesterday',
		defaultMessage: 'Yesterday',
		description: 'Last updated filter yesterday option label',
	},
	past7Days: {
		id: 'dynamic-cards-search-page.filter.last.updated.past7Days',
		defaultMessage: 'Past 7 days',
		description: 'Last updated filter past 7 days option label',
	},
	past30Days: {
		id: 'dynamic-cards-search-page.filter.last.updated.past30Days',
		defaultMessage: 'Past 30 days',
		description: 'Last updated filter past 30 days option label',
	},
	pastYear: {
		id: 'dynamic-cards-search-page.filter.last.updated.pastYear',
		defaultMessage: 'Past year',
		description: 'Last updated filter past year option label',
	},
	custom: {
		id: 'dynamic-cards-search-page.filter.last.updated.costum',
		defaultMessage: 'Custom',
		description:
			'Drop-down item label shown in the last-updated date filter on the search page, allowing the user to specify a custom date range instead of a preset.',
	},
});
